var React = require('react');

function CtaArrowDesktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.4606 7.99999C29.4606 7.31109 28.9021 6.75262 28.2132 6.75262L16.9869 6.75262C16.298 6.75262 15.7395 7.31109 15.7395 7.99999C15.7395 8.68889 16.298 9.24736 16.9869 9.24736L26.9658 9.24736L26.9658 19.2263C26.9658 19.9152 27.5243 20.4737 28.2132 20.4737C28.9021 20.4737 29.4606 19.9152 29.4606 19.2263L29.4606 7.99999ZM7.88202 30.0952L29.0952 8.88201L27.3312 7.11797L6.11798 28.3312L7.88202 30.0952Z","fill":"#E6FC5C"}));
}

CtaArrowDesktop.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = CtaArrowDesktop;

CtaArrowDesktop.default = CtaArrowDesktop;
